import { useState } from 'react';
import type { Comunicado, ComposerData } from '../types-comunicados';

const EMPTY: ComposerData = {
  title: '',
  body_html: '',
  body_json: null,
  embed_urls: [],
  is_published: false,
};

function fromComunicado(a: Comunicado): ComposerData {
  return {
    title: a.title || '',
    body_html: a.body_html || '',
    body_json: a.body_json,
    embed_urls: (a.embeds || []).map((e) => e.url),
    is_published: a.is_published,
  };
}

export function useComposerState(initial?: Comunicado) {
  const [data, setData] = useState<ComposerData>(
    initial ? fromComunicado(initial) : EMPTY
  );
  const update = <K extends keyof ComposerData>(
    key: K,
    value: ComposerData[K]
  ): void => {
    setData((d) => ({ ...d, [key]: value }));
  };
  return { data, setData, update };
}
